import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { MAX_FREE_TEXT } from './feedbackFields'

const legendSx = {
  color: 'text.primary',
  '&.Mui-focused, &.Mui-error': { color: 'text.primary' },
  p: 0,
  mb: 0.5,
  whiteSpace: 'normal',
}

// A required single-choice question: fieldset + legend, with the error text
// tied to the group. `id` is also the id of the first radio, which is what
// the error summary focuses.
export const ChoiceField = ({ id, legend, options, value, onChange, error, row = false, legendWeight = 400 }) => (
  <FormControl
    component="fieldset"
    error={!!error}
    fullWidth
    sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}
    aria-describedby={error ? `${id}-error` : undefined}
  >
    <FormLabel component="legend" sx={{ ...legendSx, fontWeight: legendWeight }}>
      {legend}
    </FormLabel>
    {error && (
      <FormHelperText id={`${id}-error`} sx={{ mx: 0, mb: 0.5, fontWeight: 700 }}>
        Error: {error}
      </FormHelperText>
    )}
    <RadioGroup row={row} name={id} value={value ?? ''} onChange={(event) => onChange(event.target.value)}>
      {options.map((option, optionIndex) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<Radio inputProps={optionIndex === 0 ? { id } : undefined} />}
          label={option.label}
          sx={{ mr: 3, minHeight: 44 }}
        />
      ))}
    </RadioGroup>
  </FormControl>
)

// An optional free-text answer whose visible question is its label.
export const TextAnswer = ({ id, question, value, onChange, rows = 3, label }) => (
  <div>
    <Typography component="label" htmlFor={id} sx={{ display: 'block', mb: 0.5 }}>
      {label ?? question} <span>(optional)</span>
    </Typography>
    <TextField
      id={id}
      value={value}
      onChange={(event) => onChange(event.target.value.slice(0, MAX_FREE_TEXT))}
      multiline={rows > 1}
      minRows={rows > 1 ? rows : undefined}
      fullWidth
      inputProps={{ maxLength: MAX_FREE_TEXT }}
    />
  </div>
)
